export const LIQUID_ENGINE = 'liquid_engine';
export const PPC_BADGE_TEST = 'ad_test';
export const BUY_IT_AGAIN = 'buy_it_again';
export const HIRE_AGAIN = 'hire_again';



// WEBPACK FOOTER //
// ./src/utils/gigTypes/constants.js